//#region src/modules/FormBuilder/components/Fields/constants.ts
var INTERNAL_CONTENT_CONTAINER_CLASSES = "rounded border-2 border-dotted border-neutral-faded p-xs";
//#endregion
export { INTERNAL_CONTENT_CONTAINER_CLASSES };

//# sourceMappingURL=constants.js.map